"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _ru = _interopRequireDefault(require("date-fns/locale/ru"));
var _datepicker = _interopRequireDefault(require("../../styles/components/datepicker"));
var _StyledComponents = require("./StyledComponents");
var _excluded = ["className", "isMobile"];
var Calendar = exports.Calendar = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledCalendar, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_datepicker["default"], null), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], (0, _extends2["default"])({
    locale: _ru["default"],
    inline: true,
    showDisabledMonthNavigation: true
  }, props)));
});
Calendar.displayName = 'Calendar';
var StyledCalendar = _styledComponents["default"].div.withConfig({
  displayName: "Calendar__StyledCalendar",
  componentId: "sc-8gqca1-0"
})(["position:relative;.react-datepicker{border:none;border-radius:0;user-select:none;display:flex;width:auto;", "}", " ", " ", " ", " ", " .react-datepicker__triangle{display:none;}.react-datepicker__aria-live{display:none;}"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && "flex-direction: column;";
}, _StyledComponents.CalendarContainer, _StyledComponents.CalendarNavigation, _StyledComponents.CalendarHeader, _StyledComponents.CalendarWeek, _StyledComponents.CalendarDay);